// Glow theme bundle — auto-generated by scripts/build-theme.mjs

// === src/scripts/accordion.js ===
// Accordion behavior — using native <details> for accessibility.
// This script only adds the rotate animation styles and keyboard-enter handling.

const style = document.createElement('style');
style.textContent = `
  details.accordion-item summary { list-style: none; }
  details.accordion-item summary::-webkit-details-marker { display: none; }
  details.accordion-item summary .accordion-icon {
    transition: transform 0.2s ease;
    display: inline-block;
  }
  details.accordion-item[open] summary .accordion-icon {
    transform: rotate(45deg);
  }
  details.accordion-item summary:focus-visible {
    outline: 2px solid var(--burgundy);
    outline-offset: -2px;
    border-radius: 4px;
  }
`;
document.head.appendChild(style);


// === src/scripts/sticky-atc.js ===
// Sticky ATC: visible once user has scrolled past the hero buy box.
const bar = document.querySelector('[data-section="sticky-atc"]');
const hero = document.querySelector('[data-section="pdp-hero"]');

if (bar && hero) {
  const observer = new IntersectionObserver(
    (entries) => {
      const heroEntry = entries[0];
      const heroVisible = heroEntry.isIntersecting;
      if (heroVisible) {
        bar.classList.add('translate-y-full');
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
      } else {
        bar.classList.remove('translate-y-full');
        bar.setAttribute('aria-hidden', 'false');
        bar.removeAttribute('inert');
      }
    },
    { threshold: 0.1, rootMargin: '-80px 0px 0px 0px' }
  );
  observer.observe(hero);
}


// === src/scripts/tab-switch.js ===
// Mobile With/Without tab toggle
document.querySelectorAll('[data-ww-tabs]').forEach((tabs) => {
  const buttons = tabs.querySelectorAll('[data-ww-tab]');
  const section = tabs.closest('section');
  const panes = section.querySelectorAll('[data-ww-pane]');

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.wwTab;
      buttons.forEach((b) => {
        const active = b.dataset.wwTab === target;
        b.setAttribute('aria-selected', String(active));
        b.classList.toggle('bg-burgundy', active);
        b.classList.toggle('text-cream', active);
        b.classList.toggle('text-mute', !active);
      });
      panes.forEach((p) => {
        // Toggle hidden on mobile; desktop's md:block utility overrides via media query.
        p.classList.toggle('hidden', p.dataset.wwPane !== target);
      });
    });
  });
});


// === src/scripts/scroll-snap.js ===
// Update pagination dots based on horizontal scroll position
function wirePaginationDots(scrollEl) {
  const section = scrollEl.closest('section');
  const pagination = section?.querySelector('[data-pagination]');
  if (!pagination) return;

  const dots = pagination.querySelectorAll('.dot');
  const tiles = scrollEl.children;
  if (!dots.length || !tiles.length) return;

  const update = () => {
    const scrollLeft = scrollEl.scrollLeft;
    const tileWidth = tiles[0].getBoundingClientRect().width + 8; // 8 = gap
    const index = Math.round(scrollLeft / tileWidth);
    dots.forEach((dot, i) => {
      const active = i === Math.min(index, dots.length - 1);
      dot.classList.toggle('w-[18px]', active);
      dot.classList.toggle('rounded-pill', active);
      dot.classList.toggle('bg-burgundy', active);
      dot.classList.toggle('w-1.5', !active);
      dot.classList.toggle('rounded-full', !active);
      dot.classList.toggle('bg-hairline', !active);
    });
  };

  scrollEl.addEventListener('scroll', update, { passive: true });
  update();
}

document.querySelectorAll('[data-scroll-snap]').forEach(wirePaginationDots);

